export * from './icon.service';
export * from './icon.component';
export * from './icon.module';